module.exports = __webpack_public_path__ + "img/image232.4169f9bb.png";